import { Component, OnInit } from '@angular/core';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';

@Component({
  selector: 'app-tender-guidelines',
  templateUrl: './tender-guidelines.component.html',
  styleUrls: ['./tender-guidelines.component.scss']
})
export class TenderGuidelinesComponent implements OnInit {

  constructor(public userUtilsService:UserUtilService) { }

  ngOnInit(): void {
  }

}
